import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { FilterField } from '../../dialogs/grid-filters/grid-filters.component';
import { SharedModule } from '../../shared.module';
import { Filters } from '../../base/base-grid.directive';

@Component({
  selector: 'app-filters-chimp',
  standalone: false,
  //imports: [SharedModule],
  templateUrl: './filters-chimp.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./filters-chimp.component.scss'],
})
export class FiltersChimpComponent {
  @Input() filters: Filters | null={};
  @Input() fields!: FilterField[];
  @Input() client_side_filters?: object={};

  @Output() removeFilter = new EventEmitter<string>();
  @Output() removeClientSideFilter = new EventEmitter<string>();

  hasFilterInFields(
    filter: string
  ): boolean {
    return this.fields.some(field => field.name === filter)
  }
  


  getField(key: string): FilterField | undefined  {
    return this.fields.find((i) => i.name === key);
  }
}
